import {
    trigger,
    state,
    style,
    transition,
    animate,
    query,
    stagger,
    keyframes,
    group,
    animateChild
} from '@angular/animations';

export const fadeIn = trigger('fadeIn', [
    transition(':enter', [
        style({ opacity: 0 }),
        animate('200ms ease-out', style({ opacity: 1 }))
    ])
]);

export const fadeInOut = trigger('fadeInOut', [
    transition(':enter', [
        style({ opacity: 0 }),
        animate('200ms ease-out', style({ opacity: 1 }))
    ]),
    transition(':leave', [
        animate('150ms ease-in', style({ opacity: 0 }))
    ])
]);

export const slideInUp = trigger('slideInUp', [
    transition(':enter', [
        style({ opacity: 0, transform: 'translateY(10px)' }),
        animate('200ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
    ]),
    transition(':leave', [
        animate('150ms ease-in', style({ opacity: 0, transform: 'translateY(10px)' }))
    ])
]);

export const slideInDown = trigger('slideInDown', [
    transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-10px)' }),
        animate('200ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
    ]),
    transition(':leave', [
        animate('150ms ease-in', style({ opacity: 0, transform: 'translateY(-10px)' }))
    ])
]);

export const slideInRight = trigger('slideInRight', [
    transition(':enter', [
        style({ opacity: 0, transform: 'translateX(20px)' }),
        animate('200ms ease-out', style({ opacity: 1, transform: 'translateX(0)' }))
    ]),
    transition(':leave', [
        animate('150ms ease-in', style({ opacity: 0, transform: 'translateX(20px)' }))
    ])
]);

export const slideInLeft = trigger('slideInLeft', [
    transition(':enter', [
        style({ opacity: 0, transform: 'translateX(-20px)' }),
        animate('200ms ease-out', style({ opacity: 1, transform: 'translateX(0)' }))
    ]),
    transition(':leave', [
        animate('150ms ease-in', style({ opacity: 0, transform: 'translateX(-20px)' }))
    ])
]);

export const scaleIn = trigger('scaleIn', [
    transition(':enter', [
        style({ opacity: 0, transform: 'scale(0.95)' }),
        animate('200ms ease-out', style({ opacity: 1, transform: 'scale(1)' }))
    ]),
    transition(':leave', [
        animate('150ms ease-in', style({ opacity: 0, transform: 'scale(0.95)' }))
    ])
]);

export const expandCollapse = trigger('expandCollapse', [
    state('collapsed', style({
        height: '0',
        opacity: '0',
        overflow: 'hidden'
    })),
    state('expanded', style({
        height: '*',
        opacity: '1'
    })),
    transition('collapsed <=> expanded', [
        animate('200ms ease-in-out')
    ])
]);

export const listStagger = trigger('listStagger', [
    transition('* => *', [
        query(':enter', [
            style({ opacity: 0, transform: 'translateY(10px)' }),
            stagger('50ms', [
                animate('200ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
            ])
        ], { optional: true })
    ])
]);

export const pulse = trigger('pulse', [
    transition('* => *', [
        animate('300ms ease-in-out', keyframes([
            style({ transform: 'scale(1)', offset: 0 }),
            style({ transform: 'scale(1.05)', offset: 0.5 }),
            style({ transform: 'scale(1)', offset: 1 })
        ]))
    ])
]);

export const shake = trigger('shake', [
    transition('* => *', [
        animate('400ms ease-in-out', keyframes([
            style({ transform: 'translateX(0)', offset: 0 }),
            style({ transform: 'translateX(-5px)', offset: 0.2 }),
            style({ transform: 'translateX(5px)', offset: 0.4 }),
            style({ transform: 'translateX(-5px)', offset: 0.6 }),
            style({ transform: 'translateX(5px)', offset: 0.8 }),
            style({ transform: 'translateX(0)', offset: 1 })
        ]))
    ])
]);

export const rotate = trigger('rotate', [
    state('default', style({ transform: 'rotate(0)' })),
    state('rotated', style({ transform: 'rotate(180deg)' })),
    transition('default <=> rotated', [
        animate('200ms ease-in-out')
    ])
]);

export const dropdownAnimation = trigger('dropdownAnimation', [
    transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-8px) scale(0.95)' }),
        animate('150ms ease-out', style({ opacity: 1, transform: 'translateY(0) scale(1)' }))
    ]),
    transition(':leave', [
        animate('100ms ease-in', style({ opacity: 0, transform: 'translateY(-8px) scale(0.95)' }))
    ])
]);

export const modalAnimation = trigger('modalAnimation', [
    transition(':enter', [
        style({ opacity: 0, transform: 'scale(0.9)' }),
        animate('200ms ease-out', style({ opacity: 1, transform: 'scale(1)' }))
    ]),
    transition(':leave', [
        animate('150ms ease-in', style({ opacity: 0, transform: 'scale(0.9)' }))
    ])
]);

export const backdropAnimation = trigger('backdropAnimation', [
    transition(':enter', [
        style({ opacity: 0 }),
        animate('200ms ease-out', style({ opacity: 1 }))
    ]),
    transition(':leave', [
        animate('150ms ease-in', style({ opacity: 0 }))
    ])
]);

export const fadeDown = trigger('fadeDown', [
    transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-8px) scale(0.95)' }),
        animate('150ms ease-out', style({ opacity: 1, transform: 'translateY(0) scale(1)' }))
    ]),
    transition(':leave', [
        animate('100ms ease-in', style({ opacity: 0, transform: 'translateY(-8px) scale(0.95)' }))
    ])
]);

export const fadeUp = trigger('fadeUp', [
    transition(':enter', [
        style({ opacity: 0, transform: 'translateY(8px) scale(0.95)' }),
        animate('150ms ease-out', style({ opacity: 1, transform: 'translateY(0) scale(1)' }))
    ]),
    transition(':leave', [
        animate('100ms ease-in', style({ opacity: 0, transform: 'translateY(8px) scale(0.95)' }))
    ])
]);


export const fadeLeft = trigger('fadeLeft', [
    transition(':enter', [
        style({ opacity: 0, transform: 'translateX(-8px) scale(0.95)' }),
        animate('150ms ease-out', style({ opacity: 1, transform: 'translateX(0) scale(1)' }))
    ]),
    transition(':leave', [
        animate('100ms ease-in', style({ opacity: 0, transform: 'translateX(-8px) scale(0.95)' }))
    ])
]);

export const fadeRight = trigger('fadeRight', [
    transition(':enter', [
        style({ opacity: 0, transform: 'translateX(8px) scale(0.95)' }),
        animate('150ms ease-out', style({ opacity: 1, transform: 'translateX(0) scale(1)' }))
    ]),
    transition(':leave', [
        animate('100ms ease-in', style({ opacity: 0, transform: 'translateX(8px) scale(0.95)' }))
    ])
]);


export const fadeInDown = trigger('fadeInDown', [
    transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-8px) scale(0.95)' }),
        animate('150ms ease-out', style({ opacity: 1, transform: 'translateY(0) scale(1)' }))
    ]),
    transition(':leave', [
        animate('100ms ease-in', style({ opacity: 0, transform: 'translateY(-8px) scale(0.95)' }))
    ])
]);

export const fadeInUp = trigger('fadeInUp', [
    transition(':enter', [
        style({ opacity: 0, transform: 'translateY(8px) scale(0.95)' }),
        animate('150ms ease-out', style({ opacity: 1, transform: 'translateY(0) scale(1)' }))
    ]),
    transition(':leave', [
        animate('100ms ease-in', style({ opacity: 0, transform: 'translateY(8px) scale(0.95)' }))
    ])
]);

export const staggerFadeInit = trigger('staggerFadeInit', [
    transition(':enter', [
        query('.stagger-item', [
            style({ opacity: 0, transform: 'translateY(20px)' }),
            stagger('70ms', [
                animate('500ms cubic-bezier(0.25, 1, 0.25, 1)', style({ opacity: 1, transform: 'translateY(0)' }))
            ])
        ], { optional: true })
    ])
]);

export const routeAnimation = trigger('routeAnimations', [
    transition('* <=> *', [
        // Leave : masquer instantanément sans changer le layout
        query(':leave', [
            animate('0ms', style({ opacity: 0, height: 0, overflow: 'hidden' }))
        ], { optional: true }),
        // Enter : fade-in subtil, la page garde son layout naturel
        query(':enter', [
            style({ opacity: 0 }),
            animate('220ms ease-out', style({ opacity: 1 }))
        ], { optional: true }),
    ])
]);

export const tabContent = trigger('tabContent', [
    transition(':enter', [
        style({ opacity: 0, transform: 'translateY(12px)' }),
        animate('280ms cubic-bezier(0.25, 0.8, 0.25, 1)', style({ opacity: 1, transform: 'translateY(0)' }))
    ]),
    transition(':leave', [
        animate('180ms cubic-bezier(0.25, 0.8, 0.25, 1)', style({ opacity: 0, transform: 'translateY(-8px)' }))
    ])
]);

export const detailStagger = trigger('detailStagger', [
    transition('* => *', [
        query(':enter', [
            style({ opacity: 0, transform: 'translateY(16px)' }),
            stagger('60ms', [
                animate('350ms cubic-bezier(0.25, 0.8, 0.25, 1)', style({ opacity: 1, transform: 'translateY(0)' }))
            ])
        ], { optional: true })
    ])
]);

export const smoothExpand = trigger('smoothExpand', [
    transition(':enter', [
        style({ height: 0, opacity: 0, overflow: 'hidden' }),
        animate('250ms cubic-bezier(0.4, 0, 0.2, 1)', style({ height: '*', opacity: 1 }))
    ]),
    transition(':leave', [
        style({ overflow: 'hidden' }),
        animate('200ms cubic-bezier(0.4, 0, 0.2, 1)', style({ height: 0, opacity: 0 }))
    ])
]);

export const slidePanel = trigger('slidePanel', [
    transition(':enter', [
        style({ opacity: 0, transform: 'translateX(30px)' }),
        animate('350ms cubic-bezier(0.25, 0.8, 0.25, 1)', style({ opacity: 1, transform: 'translateX(0)' }))
    ]),
    transition(':leave', [
        animate('250ms cubic-bezier(0.25, 0.8, 0.25, 1)', style({ opacity: 0, transform: 'translateX(30px)' }))
    ])
]);

export const adminPageTransition = trigger('adminPageTransition', [
    transition('* <=> *', [
        query(':leave', [
            animate('0ms', style({ opacity: 0, height: 0, overflow: 'hidden' }))
        ], { optional: true }),
        query(':enter', [
            style({ opacity: 0 }),
            animate('220ms ease-out', style({ opacity: 1 }))
        ], { optional: true }),
    ])
]);

export const alertToast = trigger('alertToast', [
    transition(':enter', [
        style({ opacity: 0, transform: 'translateX(30px) scale(0.95)' }),
        animate('300ms cubic-bezier(0.25, 0.8, 0.25, 1)',
            style({ opacity: 1, transform: 'translateX(0) scale(1)' }))
    ]),
    transition(':leave', [
        animate('200ms cubic-bezier(0.25, 0.8, 0.25, 1)',
            style({ opacity: 0, transform: 'translateX(30px) scale(0.95)' }))
    ])
]);

